import { Component, inject } from '@angular/core';
import { NavigationService } from '../../../Services/navigation.service';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';

@Component({
  selector: 'app-secondary-nav',
  standalone: true,
  imports: [
    COMMON_IMPORTS
  ],
  templateUrl: './secondary-nav.component.html',
  styleUrls: ['./secondary-nav.component.scss']
})
export class SecondaryNavComponent {
  public navigationService = inject(NavigationService);
}